<template>
  <div class="life-page">
    <section class="life-panel">
      <div class="life-panel__head">
        <h2 class="life-panel__title">发布查询</h2>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="openEditor()">新增发布</el-button>
      </div>
      <div class="life-filter">
        <el-select
          v-model="filters.communityId"
          placeholder="全部小区"
          clearable
          filterable
          style="width: 200px"
        >
          <el-option
            v-for="item in communityOptions"
            :key="item.communityId"
            :label="item.name"
            :value="item.communityId"
          />
        </el-select>
        <el-select v-model="filters.productId" placeholder="产品" clearable filterable style="width: 200px">
          <el-option v-for="p in productOptions" :key="p.productId" :label="p.name" :value="p.productId" />
        </el-select>
        <el-select v-model="filters.state" placeholder="状态" clearable style="width: 120px">
          <el-option label="上架" value="1002" />
          <el-option label="下架" value="1001" />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
    </section>

    <section class="life-panel">
      <div class="life-panel__head">
        <h2 class="life-panel__title">产品发布</h2>
        <span class="life-muted">运营手工维护产品后向各小区上架（无对方价目同步）</span>
      </div>
      <el-table v-loading="loading" :data="rows" border>
        <el-table-column prop="communityName" label="小区" min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.communityName || scope.row.communityId || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="productName" label="产品名称" min-width="140" />
        <el-table-column prop="catalogName" label="分类" width="100" />
        <el-table-column label="预付价" width="110" align="center">
          <template slot-scope="scope">
            <span class="life-money">{{ scope.row.prepayAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.state === '1002' ? 'success' : 'info'" size="small">
              {{ scope.row.state === '1002' ? '上架' : '下架' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="70" align="center" />
        <el-table-column prop="startTime" label="开始时间" width="170" />
        <el-table-column prop="endTime" label="结束时间" width="170" />
        <el-table-column prop="createTime" label="创建时间" width="170" />
        <el-table-column label="操作" width="140" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" @click="openEditor(scope.row)">编辑</el-button>
            <el-button type="text" icon="el-icon-delete" style="color: #f56c6c" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="life-pagination" :current-page.sync="page.current" :page-size="page.size"
        :page-sizes="[10, 20, 50]" :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="changeSize" @current-change="load" />
    </section>

    <el-dialog :title="form.publicationId ? '编辑发布' : '新增发布'" :visible.sync="editorVisible" width="560px" @closed="onDialogClosed">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="小区" prop="communityId">
          <el-select
            v-model="form.communityId"
            placeholder="请选择小区"
            filterable
            style="width: 100%"
            :disabled="!!form.publicationId"
          >
            <el-option
              v-for="item in communityOptions"
              :key="item.communityId"
              :label="item.name"
              :value="item.communityId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="产品" prop="productId">
          <el-select v-model="form.productId" placeholder="请选择产品" filterable style="width: 100%">
            <el-option v-for="p in productOptions" :key="p.productId" :label="p.name + ' (' + p.externalProductId + ')'" :value="p.productId" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.state">
            <el-radio label="1002">上架</el-radio>
            <el-radio label="1001">下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort" :min="0" :max="9999" controls-position="right" style="width: 100%" />
        </el-form-item>
        <el-form-item label="开始时间">
          <el-date-picker v-model="form.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="可选" style="width: 100%" clearable />
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker v-model="form.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="可选" style="width: 100%" clearable />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editorVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { listPublications, savePublication, updatePublication, deletePublication, listProducts } from '@/api/life/homeServiceApi'
import { listAdminCommunitys } from '@/api/owner/adminOwnerApi'

function emptyForm() {
  return {
    publicationId: '', communityId: '', productId: '', state: '1002', sort: 0,
    startTime: '', endTime: ''
  }
}

export default {
  name: 'HomeServicePublicationList',
  data() {
    return {
      loading: false, saving: false, editorVisible: false,
      rows: [],
      productOptions: [],
      communityOptions: [],
      filters: { communityId: '', productId: '', state: '' },
      page: { current: 1, size: 10, total: 0 },
      form: emptyForm(),
      rules: {
        communityId: [{ required: true, message: '请选择小区', trigger: 'change' }],
        productId: [{ required: true, message: '请选择产品', trigger: 'change' }]
      }
    }
  },
  created() {
    this.loadCommunities()
    this.loadProducts()
    this.load()
  },
  methods: {
    async loadCommunities() {
      try {
        const res = await listAdminCommunitys({ page: 1, row: 500 })
        this.communityOptions = res.data || []
      } catch (_) {
        this.communityOptions = []
      }
    },
    async loadProducts() {
      try {
        const res = await listProducts({ page: 1, row: 500 })
        this.productOptions = res.data || []
      } catch (_) { /* ignore */ }
    },
    async load() {
      this.loading = true
      try {
        const res = await listPublications({ ...this.filters, page: this.page.current, row: this.page.size })
        this.rows = res.data || []
        this.page.total = Number(res.total || 0)
      } catch (error) {
        this.$message.error(error.message || '加载发布列表失败')
      } finally { this.loading = false }
    },
    search() { this.page.current = 1; this.load() },
    reset() { this.filters = { communityId: '', productId: '', state: '' }; this.search() },
    changeSize(size) { this.page.size = size; this.load() },
    openEditor(row) {
      this.loadProducts()
      if (row) {
        this.form = { ...row, sort: Number(row.sort) || 0 }
      } else {
        this.form = emptyForm()
      }
      this.editorVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    onDialogClosed() {
      this.$refs.formRef && this.$refs.formRef.resetFields()
      this.form = emptyForm()
    },
    submit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.saving = true
        try {
          const payload = { ...this.form, sort: String(this.form.sort) }
          if (!payload.startTime) delete payload.startTime
          if (!payload.endTime) delete payload.endTime
          if (this.form.publicationId) {
            await updatePublication(payload)
          } else {
            await savePublication(payload)
          }
          this.$message.success('发布信息已保存')
          this.editorVisible = false
          this.load()
        } catch (error) {
          this.$message.error(error.message || '保存失败')
        } finally { this.saving = false }
      })
    },
    handleDelete(row) {
      this.$confirm(`确认删除发布「${row.productName || row.productId}」？`, '提示', { type: 'warning' }).then(async () => {
        try {
          await deletePublication({ publicationId: row.publicationId })
          this.$message.success('已删除')
          if (this.rows.length === 1 && this.page.current > 1) this.page.current--
          this.load()
        } catch (error) {
          this.$message.error(error.message || '删除失败')
        }
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/views/lifeService/life.scss';
</style>
